var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "applyGuildForm",
      staticClass: "applybox",
      attrs: {
        model: _vm.applyGuildForm,
        rules: _vm.rules,
        "label-width": "120px",
        size: "small"
      }
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: _vm.$t("m.agency_name"), prop: "guildName" } },
        [
          _c("el-input", {
            attrs: {
              maxlength: "20",
              placeholder: _vm.$t("m.agency_name_input")
            },
            model: {
              value: _vm.applyGuildForm.guildName,
              callback: function($$v) {
                _vm.$set(
                  _vm.applyGuildForm,
                  "guildName",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "applyGuildForm.guildName"
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "tip_txt" }, [
            _vm._v(_vm._s(_vm.$t("m.agency_name_input_note")))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          staticStyle: { "margin-bottom": "0" },
          attrs: { label: _vm.$t("m.agency_logo"), prop: "guildLogo" }
        },
        [
          _c(
            "el-upload",
            {
              staticClass: "avatar-uploader",
              class: { hideUploadBtn: _vm.guildLogoArr.length > 0 },
              attrs: {
                action: _vm.uploadAction,
                "list-type": "picture-card",
                multiple: false,
                limit: 1,
                "on-remove": _vm.removeLogoUpload,
                "on-success": _vm.onUploadLogo,
                "on-error": _vm.onUploadError,
                "file-list": _vm.guildLogoArr,
                "before-upload": _vm.beforeLogoUpload,
                accept: ".jpg,.png,.jpeg"
              }
            },
            [_c("i", { staticClass: "el-icon-plus avatar-uploader-icon" })]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "tip_txt" }, [
            _vm._v(_vm._s(_vm.$t("m.agency_logo_unpload_note")))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("m.agency_contact_name"),
            prop: "guildContacts"
          }
        },
        [
          _c("el-input", {
            attrs: {
              maxlength: "20",
              placeholder: _vm.$t("m.user_contact_name")
            },
            on: {
              input: function($event) {
                _vm.applyGuildForm.guildContacts = _vm.$notNum(
                  _vm.applyGuildForm.guildContacts
                )
              }
            },
            model: {
              value: _vm.applyGuildForm.guildContacts,
              callback: function($$v) {
                _vm.$set(
                  _vm.applyGuildForm,
                  "guildContacts",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "applyGuildForm.guildContacts"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("m.agency_contact_phone"),
            prop: "guildContactsPhone"
          }
        },
        [
          _c(
            "div",
            { staticClass: "fc-flex fc-flex-vcenter" },
            [
              _c(
                "div",
                {
                  staticClass: "seledArea",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.showCountryFun.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "flag_icon",
                    attrs: { src: _vm.selCountry.logo }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "countrynum" }, [
                    _vm._v("+" + _vm._s(_vm.selCountry.countryNum))
                  ]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "select_icon",
                    attrs: {
                      src:
                        _vm.showCountry && _vm.$store.state.isShowSelArea
                          ? require("../../../assets/img/icon_up.png")
                          : require("../../../assets/img/icon_down.png")
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  minlength: "6",
                  placeholder: _vm.$t("m.agency_contact_phone")
                },
                on: {
                  input: function($event) {
                    _vm.applyGuildForm.guildContactsPhone = _vm.$num(
                      _vm.applyGuildForm.guildContactsPhone
                    )
                  }
                },
                model: {
                  value: _vm.applyGuildForm.guildContactsPhone,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.applyGuildForm,
                      "guildContactsPhone",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "applyGuildForm.guildContactsPhone"
                }
              }),
              _vm._v(" "),
              _vm.showCountry && _vm.$store.state.isShowSelArea
                ? _c(
                    "div",
                    { staticClass: "selarea_box" },
                    [
                      _c("sel-area", {
                        on: { countryOption: _vm.countryOptionFun }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("m.agency_whatsapp"),
            prop: "guildAdminWhatsApp"
          }
        },
        [
          _c("el-input", {
            attrs: {
              placeholder: _vm.$t("m.agency_whatsapp_contact"),
              maxlength: "50"
            },
            model: {
              value: _vm.applyGuildForm.guildAdminWhatsApp,
              callback: function($$v) {
                _vm.$set(
                  _vm.applyGuildForm,
                  "guildAdminWhatsApp",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "applyGuildForm.guildAdminWhatsApp"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: _vm.$t("m.email"), prop: "email" } },
        [
          _c("el-input", {
            attrs: { placeholder: _vm.$t("m.email"), maxlength: "70" },
            model: {
              value: _vm.applyGuildForm.email,
              callback: function($$v) {
                _vm.$set(
                  _vm.applyGuildForm,
                  "email",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "applyGuildForm.email"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("m.agency_use_lang"),
            prop: "guildAdminUserLang"
          }
        },
        [
          _c(
            "el-select",
            {
              attrs: {
                filterable: "",
                multiple: "",
                placeholder: _vm.$t("m.select")
              },
              model: {
                value: _vm.applyGuildForm.guildAdminUserLang,
                callback: function($$v) {
                  _vm.$set(_vm.applyGuildForm, "guildAdminUserLang", $$v)
                },
                expression: "applyGuildForm.guildAdminUserLang"
              }
            },
            _vm._l(_vm.guildAdminUserLangArr, function(item) {
              return _c("el-option", {
                key: item.key,
                attrs: { label: item.name, value: item.key }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: _vm.$t("m.agency_head_ID"), prop: "guildAdminId" } },
        [
          _c("el-input", {
            attrs: {
              maxlength: "10",
              disabled: !!this.$store.state.userInfo.appUserId,
              placeholder: _vm.$t("m.agency_ID_input")
            },
            on: {
              input: function($event) {
                _vm.applyGuildForm.guildAdminId = _vm.applyGuildForm.guildAdminId.replace(
                  /\D/g,
                  ""
                )
              }
            },
            model: {
              value: _vm.applyGuildForm.guildAdminId,
              callback: function($$v) {
                _vm.$set(
                  _vm.applyGuildForm,
                  "guildAdminId",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "applyGuildForm.guildAdminId"
            }
          }),
          _vm._v(" "),
          _vm.guildAdminNickname
            ? _c(
                "span",
                {
                  staticClass: "el-form-item__error",
                  staticStyle: { margin: "0" }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("m.nickname")) +
                      " 【" +
                      _vm._s(_vm.guildAdminNickname) +
                      "】\n      "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _vm.signState === 1
                    ? _c("p", { staticStyle: { color: "red" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("m.cant_commit")) +
                            "\n      "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.signState === 2
                    ? _c("p", { staticStyle: { color: "red" } }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("m.cant_commit_1")) +
                            "\n      "
                        )
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.getnameloading
            ? _c("i", { staticClass: "el-icon-loading el-form-item__error" })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "phoneSex" },
        [
          _c("el-form-item", { attrs: { label: _vm.$t("m.reg_country") } }, [
            _c("div", [_vm._v(_vm._s(_vm.phoneCountry))])
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("m.app_phone"), "label-width": "126px" } },
            [_c("div", [_vm._v(_vm._s(_vm.mobile))])]
          ),
          _vm._v(" "),
          _c("el-form-item", { attrs: { label: _vm.$t("m.gender") } }, [
            _vm.sex === 0
              ? _c("div", [_vm._v(_vm._s(_vm.$t("m.female")))])
              : _vm._e(),
            _vm._v(" "),
            _vm.sex === 1
              ? _c("div", [_vm._v(_vm._s(_vm.$t("m.male")))])
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            label: _vm.$t("m.inhand_ID_photo"),
            prop: "guildAdminCardJustPic"
          }
        },
        [
          _c("div", { staticClass: "zhizhaopic" }, [
            _c(
              "div",
              [
                _c(
                  "el-upload",
                  {
                    staticClass: "avatar-uploader",
                    class: {
                      hideUploadBtn: _vm.guildAdminCardJustPicArr.length > 0
                    },
                    attrs: {
                      action: _vm.uploadAction,
                      "list-type": "picture-card",
                      multiple: false,
                      limit: 1,
                      "before-upload": _vm.beforePicUpload,
                      "on-remove": _vm.removeBusinessPicUpload,
                      "on-success": _vm.onUploadBusinessPic,
                      "on-error": _vm.onUploadError,
                      "file-list": _vm.guildAdminCardJustPicArr,
                      accept: ".jpg,.png,.jpeg"
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-plus avatar-uploader-icon"
                    })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "notebox" }, [
              _c("img", {
                staticClass: "zhizhaopic",
                attrs: {
                  src: require("../../../assets/img/zhengjian.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "note" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("m.upload_note_t")) + ":")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "1、" + _vm._s(_vm.$t("m.agency_self_inhand_ID")) + ";"
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("2、" + _vm._s(_vm.$t("m.photo_must_clearly")) + "; ")
                ])
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: { label: _vm.$t("m.mian_form_country"), prop: "anchorCountry" }
        },
        [
          _c(
            "el-select",
            {
              attrs: {
                filterable: "",
                multiple: "",
                placeholder: _vm.$t("m.select")
              },
              model: {
                value: _vm.applyGuildForm.anchorCountry,
                callback: function($$v) {
                  _vm.$set(_vm.applyGuildForm, "anchorCountry", $$v)
                },
                expression: "applyGuildForm.anchorCountry"
              }
            },
            _vm._l(_vm.anchorCountryArr, function(item) {
              return _c("el-option", {
                key: item.coding + item.id,
                attrs: { label: item.content, value: item.coding }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: _vm.$t("m.invite_code"), prop: "inviteCode" } },
        [
          _c("el-input", {
            attrs: {
              disabled: _vm.linkInviteCode,
              oninput: "value=value.replace(/\\D/g,'')",
              maxlength: 6,
              placeholder: _vm.$t("m.invite_code")
            },
            model: {
              value: _vm.applyGuildForm.inviteCode,
              callback: function($$v) {
                _vm.$set(
                  _vm.applyGuildForm,
                  "inviteCode",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "applyGuildForm.inviteCode"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: _vm.$t("m.host_num"), prop: "anchorNum" } },
        [
          _c("el-input", {
            attrs: {
              oninput: "value=value.replace(/^(0+)|[^\\d]+/g,'')",
              maxlength: "9",
              placeholder: _vm.$t("m.enter_host_num")
            },
            model: {
              value: _vm.applyGuildForm.anchorNum,
              callback: function($$v) {
                _vm.$set(
                  _vm.applyGuildForm,
                  "anchorNum",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "applyGuildForm.anchorNum"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: _vm.$t("m.platform"), prop: "cooperationPlatform" } },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              placeholder: _vm.$t("m.many_platforms")
            },
            model: {
              value: _vm.applyGuildForm.cooperationPlatform,
              callback: function($$v) {
                _vm.$set(
                  _vm.applyGuildForm,
                  "cooperationPlatform",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "applyGuildForm.cooperationPlatform"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: { display: "flex", "line-height": "2.2", width: "100%" }
        },
        [
          _c(
            "div",
            { staticStyle: { width: "90%" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("m.statement"), prop: "monthFlow" } },
                [
                  _c("el-input", {
                    attrs: {
                      oninput: "value=value.replace(/\\D/g,'')",
                      maxlength: "9",
                      placeholder: _vm.$t("m.enter_income")
                    },
                    model: {
                      value: _vm.applyGuildForm.monthFlow,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.applyGuildForm,
                          "monthFlow",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "applyGuildForm.monthFlow"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.$t("m.usd")))])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { staticStyle: { "text-align": "right", "margin-bottom": "20px" } },
        [
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                loading: _vm.btnLoading,
                disabled: _vm.signState === 1 || _vm.signState === 2
              },
              on: {
                click: function($event) {
                  return _vm.submitForm("applyGuildForm")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("m.submit")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e7381fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e7381fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/apply/components/applyform.vue
// module id = null
// module chunks = 